<template>
  <table-ag
    ref="agLeaders"
    :row-data="datos"
    :columnDefs="columns"
    :typeSelection="limitSelection > 1 ? 'multiple' : 'single'"
    :limitSelection="limitSelection"
    :component-menu="componentMenu"
    :onDeselectEmptyData="true"
    @selected="selected"
  ></table-ag>
</template>

<script>
import tableAg from "../../dashboard/tableAg.vue";
import menuTableLeaders from "./menuTableLeaders.vue";
export default {
  data() {
    return {
      columns: [
        {
          field: "empleado",
          checkboxSelection: true,
          showDisabledCheckboxes: true,
          editable: false,
          tooltipValueGetter: (params) => {
            return params.value;
          },
          valueGetter: (params) => {
            return params.data[params.colDef.field].nombre;
          },
        },
        {
          field: "ncolaboradores",
          valueGetter: (params) => {
            return params.data.ncolaboradores;
          },
          tooltipValueGetter: (params) => {
            return `${params.value} ${
              params.value > 1 ? "Colaboradores" : "Colaborador"
            }`;
          },
          headerName: "N",
          filter: "agTextColumnFilter",
          editable: false,
          width: 120,
        },
        {
          field: "colaboradores",
          valueGetter: (params) => {
            return this.getValues(params, "liderT");
          },
          tooltipValueGetter: (params) => {
            return params.value.toFixed(2);
          },
          headerName: "Líder PHD",
          filter: "agTextColumnFilter",
          editable: false,
          cellRenderer: this.valueEmpty,
          cellClass: (params) => this.cellClassRules(params, "liderT"),
          getQuickFilterText: (params) => {
            return "";
          },
        },
        {
          field: "colaboradores",
          valueGetter: (params) => {
            return this.getValues(params, "cond");
          },
          tooltipValueGetter: (params) => {
            return params.value.toFixed(2);
          },
          headerName: "Conocimiento",
          filter: "agTextColumnFilter",
          editable: false,
          cellRenderer: this.valueEmpty,
          cellClass: (params) => this.cellClassRules(params, "cond"),
          getQuickFilterText: (params) => {
            return "";
          },
        },
        {
          field: "colaboradores",
          headerName: "Resultados",
          valueGetter: (params) => {
            return this.getValues(params, "resuld");
          },
          tooltipValueGetter: (params) => {
            return params.value.toFixed(2);
          },
          filter: "agTextColumnFilter",
          editable: false,
          cellRenderer: this.valueEmpty,
          cellClass: (params) => this.cellClassRules(params, "resuld"),
          getQuickFilterText: (params) => {
            return "";
          },
        },
        {
          field: "colaboradores",
          headerName: "Sí mismo",
          valueGetter: (params) => {
            return this.getValues(params, "dsmd");
          },
          tooltipValueGetter: (params) => {
            return params.value.toFixed(2);
          },
          filter: "agTextColumnFilter",
          editable: false,
          cellRenderer: this.valueEmpty,
          cellClass: (params) => this.cellClassRules(params, "dsmd"),
          getQuickFilterText: (params) => {
            return "";
          },
        },
        {
          field: "colaboradores",
          headerName: "Personas",
          filter: "agTextColumnFilter",
          valueGetter: (params) => {
            return this.getValues(params, "gperd");
          },
          tooltipValueGetter: (params) => {
            return params.value.toFixed(2);
          },
          editable: false,
          cellRenderer: this.valueEmpty,
          cellClass: (params) => this.cellClassRules(params, "gperd"),
          getQuickFilterText: (params) => {
            return "";
          },
        },
        {
          field: "colaboradores",
          headerName: "Relaciones",
          valueGetter: (params) => {
            return this.getValues(params, "reld");
          },
          tooltipValueGetter: (params) => {
            return params.value.toFixed(2);
          },
          filter: "agTextColumnFilter",
          editable: false,
          cellRenderer: this.valueEmpty,
          cellClass: (params) => this.cellClassRules(params, "reld"),
          getQuickFilterText: (params) => {
            return "";
          },
        },
      ],
      componentMenu: () => {
        return {
          render: (h) =>
            h(menuTableLeaders, {
              props: {},
              on: {
                selectTypeData: this.selectTypeData,
              },
            }),
        };
      },
    };
  },
  props: {
    datos: Array,
    limitSelection: Number,
  },
  methods: {
    getValues(p, group) {
      const type = p.colDef.field;
      const v = type !== "autoconciencia" ? "e" : "v";
      return parseFloat(p.data[p.colDef.field][group][v]);
    },
    valueEmpty() {
      return "";
    },
    cellClassRules(p, group) {
      const type = p.colDef.field;
      p = p.data[p.colDef.field][group].r;
      if (p !== null) {
        const rang = {
          colaboradores: {
            0: "rangoL0",
            1: "rangoL1",
            2: "rangoL2",
            3: "rangoL3",
            4: "rangoL4",
            5: "rangoL5",
            6: "rangoL6",
          },
          autoevaluacion: {
            0: "rangoL0",
            1: "rangoL1",
            2: "rangoL2",
            3: "rangoL3",
            4: "rangoL4",
            5: "rangoL5",
            6: "rangoL6",
          },
          autoconciencia: { 0: "auto0", 1: "auto1", 2: "auto2", 3: "auto3" },
        };
        return rang[type][p];
      }
      return type === "autoconciencia" ? "auto0" : "rango0";
    },
    selected(i) {
      this.$emit("setFilterTable", i);
    },
    deselect() {
      this.$refs.agLeaders.deselectAll();
    },
    deselectOne(filter) {
      this.$refs.agLeaders.deselectOne(filter);
    },
    selectTypeData(type) {
      const notEdit = ["empleado"];
      this.$refs.agLeaders.showData(type, notEdit);
    },
  },
  created() {},
  components: {
    tableAg,
  },
};
</script>
<style lang="scss">
/* Backgrounds Rangos */

.rangoL1 {
  background-color: #f4cdcd !important;
  border: solid 1px #f5b6b6;
}

.rangoL2 {
  background-color: #facca5 !important;
  border: solid 1px #f8b880;
}

.rangoL3 {
  background-color: #fff2cc !important;
  border: solid 1px #f8e09a;
}

.rangoL4 {
  background-color: #d9ead3 !important;
  border: solid 1px #baefa8;
}

.rangoL5 {
  background-color: #a2c4c9 !important;
  border: solid 1px #8cb7be;
}

.rangoL6 {
  background-color: #c8d9f7 !important;
  border: solid 1px #a0bcee;
}

.rangoL0 {
  background-color: #eceeec;
  border: solid 1px #d4d5d3;
}

/* Backgrounds RangosAutoc */

.auto1 {
  background-color: #d9ead3 !important;
  border: solid 1px #baefa8;
}

.auto2 {
  background-color: #fff2cc !important;
  border: solid 1px #f8e09a;
}

.auto3 {
  background-color: #f4cdcd !important;
  border: solid 1px #f5b6b6;
}

.auto0 {
  background-color: #eceeec;
  border: solid 1px #d4d5d3;
}
</style>



// WEBPACK FOOTER //
// src/components/lideres/components/tableLeaders.vue